const wordpressTermsPostId = '695';
const wordpressPolicyPostId = '691';
const wordPressSiteName = 'amigoapp.wordpress.com';
const wordpressPublicApiUrl = 'public-api.wordpress.com';

const fetchPost = async (postId) => {
  try {
    const response = await fetch(
      `https://${wordpressPublicApiUrl}/rest/v1.1/sites/${wordPressSiteName}/posts/${postId}`
    );

    if (!response.ok) {
      return { data: null, error: new Error(`HTTP error ${response.status} for post ${postId}`) };
    }

    const data = await response.json();
    return { data, error: null };
  } catch (error) {
    return { data: null, error };
  }
};

export const fetchTerms = () => fetchPost(wordpressTermsPostId);
export const fetchPrivacyPolicy = () => fetchPost(wordpressPolicyPostId);
